export default {
    locations: [],
}